import * as Sentry from '@sentry/browser'

const looopEnvironment = process.env.LOOOP_ENVIRONMENT || 'dev'
Sentry.init({
  dsn: process.env.SENTRY_FRONTEND_DSN,
  enabled: !['test', 'dev'].includes(looopEnvironment),
  environment: looopEnvironment,
  release: window.LOOOP.releasedGitHash,
  ignoreErrors: ['ResizeObserver', 'Maximum update depth exceeded'],
  denyUrls: [
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i
  ]
})
